import { SPACING, BORDER_RADIUS } from '../../constants/theme';

const TimelineEventDot = ({ icon: Icon, backgroundColor }) => {
  return (
    <div
      style={{
        width: SPACING.XXL,
        height: SPACING.XXL,
        borderRadius: BORDER_RADIUS.ROUND,
        backgroundColor,
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'none',
      }}
    >
      <Icon style={{ color: '#fff', fontSize: '14px', background: 'none' }} />
    </div>
  );
};

export default TimelineEventDot;
